import { PayloadAction, createSlice } from '@reduxjs/toolkit'

const initialState: any = {
  locations: [],
  serviceType: 'D2D',
  draggablePin: {},
  expandPorts: [],
  isFocusPickup: false,
  isFocusDestination: false,
  isFocusPickupOSA: false,
}
const locationsSlice = createSlice({
  name: 'locations',
  initialState,
  reducers: {
    addLocation: (state: any, action: PayloadAction<any>) => {
      if (!state.locations.length) {
        state.locations.push(action.payload)
      } else {
        if (action.payload.isPickup) {
          state.locations = [action.payload, ...state.locations]
        } else {
          state.locations.push(action.payload)
        }
      }
    },
    updateLocation: (state: any, action: PayloadAction<any>) => {
      const { index } = action.payload.location
      const idx = state.locations.findIndex(({ location }: any) => location.index === index)
      if (idx !== -1) {
        state.locations[idx] = action.payload
      } else {
        if (action.payload.isPickup) {
          state.locations = [action.payload, ...state.locations]
        } else {
          state.locations.push(action.payload)
          state.locations[idx] = action.payload
        }
      }
    },
    updateListLocations: (state: any, action: PayloadAction<any>) => {
      state.locations = action.payload
    },
    removeLocation: (state: any, action: PayloadAction<any>) => {
      state.locations.splice(action.payload.index, 1)
    },
    updateServiceType: (state: any, action: PayloadAction<any>) => {
      state.serviceType = action.payload
    },
    addDraggablePin: (state: any, action: PayloadAction<any>) => {
      state.draggablePin = action.payload
    },
    expandAnIsland: (state: any, action: PayloadAction<any>) => {
      state.expandPorts = action.payload
    },
    setIsFocusPickupOSA: (state: any, action: PayloadAction<any>) => {
      state.isFocusPickupOSA = action.payload
    },
    setIsFocusPickup: (state: any, action: PayloadAction<any>) => {
      state.isFocusPickup = action.payload
    },
    setIsFocusDestination: (state: any, action: PayloadAction<any>) => {
      state.isFocusDestination = action.payload
    },
  },
})
export const locationsAction = locationsSlice.actions
export default locationsSlice
